'use client';
import React, { memo } from 'react';

import { IButton, ITypo } from '@/app/_components/common';
import { TriangleIcon } from '@/app/assets/Icons';
import { cn } from '@nextui-org/react';

interface IProps {
	item: any;
	isSelected: boolean;
	handleSelectCourse: (item: any) => void;
}

const CourseItem: React.FC<IProps> = ({
	item,
	isSelected,
	handleSelectCourse,
}) => {
	return (
		<div className="relative">
			<IButton
				className="ml-2 h-fit min-h-10 w-full min-w-[151px] justify-start rounded-lg px-6 lg:min-h-20 lg:min-w-[584px] lg:rounded-xl"
				onClick={() => handleSelectCourse(item)}
				variant={isSelected ? 'default' : 'light'}
			>
				<ITypo
					size={14}
					weight="semi"
					className={cn('lg:text-20', {
						'text-black-1': !isSelected,
					})}
				>
					{item?.name}
				</ITypo>
			</IButton>
			{isSelected && (
				<TriangleIcon className="text-bittersweet absolute -right-5 top-1/2 -z-[1] hidden -translate-y-1/2 rotate-90 lg:inline" />
			)}
		</div>
	);
};

export default memo(CourseItem);
